'use strict';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {FormComponent} from "./component";

@NgModule({
  imports     : [
    BrowserModule
  ],
  declarations: [FormComponent],
  exports     : [FormComponent]
})
export class LKForm {
}
